import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CryptoJsService } from './crypto-js.service';
import { HttpParams } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  private userSubject = new BehaviorSubject<any>(this.getUserPermissionFromStorage());
  public user$ = this.userSubject.asObservable();

  private unidades = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
  private decenas = ["", "diez", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
  private especiales = ["diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve"];
  private centenas = ["cien", "ciento", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];

  constructor(private readonly localStorage: CryptoJsService) { }

  convertNumtoLetters(numero: number): string {
    const num = numero.toFixed(2)
    const parteEntera = Math.floor(Number(num));
    const parteDecimal = Math.round((Number(num) - parteEntera) * 100);

    const parteEnteraEnLetras = this.convertirParteEntera(parteEntera);
    const parteDecimalEnLetras = parteDecimal > 0 ? `con ${this.convertirParteEntera(parteDecimal)}/100` : "";

    return `${parteEnteraEnLetras} ${parteDecimalEnLetras}`.trim();
  }

  private convertirParteEntera(numero: number): string {
    if (numero === 0) {
      return "cero";
    } else if (numero < 10) {
      return this.unidades[numero];
    } else if (numero < 20) {
      return this.especiales[numero - 10];
    } else if (numero < 100) {
      const decena = Math.floor(numero / 10);
      const unidad = numero % 10;
      if (unidad === 0) {
        return this.decenas[decena];
      } else {
        return `${this.decenas[decena]} y ${this.unidades[unidad]}`;
      }
    } else if (numero < 1000) {
      const centena = Math.floor(numero / 100);
      const resto = numero % 100;
      if (resto === 0 && centena === 1) {
        return "cien";
      } else if (resto === 0) {
        return this.centenas[centena];
      } else {
        return `${this.centenas[centena]} ${this.convertirParteEntera(resto)}`;
      }
    } else {
      return "Número fuera de rango";
    }
  }

  private getUserPermissionFromStorage() {

    return null;
  }

  setUserPermission(assignedProjects: any) {

    const permissionLevel = this.localStorage.getItem('permissionLevel');
    ////console.log('permissionLevel', this.localStorage.getItem('permissionLevel'));
    ////console.log('assignedProjects', assignedProjects);

    ////console.log('permissionLevel', permissionLevel);
    let projects = assignedProjects.find(item => item.permissionLevel === permissionLevel);

    let superAdminMenu = assignedProjects.find(item => item.permissionLevel === 'admin_menu');
    ////console.log('|assignedSuperAdmin', superAdminMenu);
    if (superAdminMenu) {
      this.localStorage.setItem('assignedSuperAdmin', superAdminMenu);
    }
    this.localStorage.setItem('assignedProjects', projects.projects);

    ////console.log('projects', projects);

    this.userSubject.next(assignedProjects);
  }

  clearUserPermission() {
    localStorage.removeItem('userPermission');
    this.userSubject.next(null);
  }

  getStatusLabel(statusCode: string | undefined): string {
    switch (statusCode) {
      case 'R':
        return 'REGULARIZADO';
      case 'A':
        return 'ANULADO';
      case 'N':
        return 'NUEVO';
      case 'CA':
        return 'CAMBIO DE PLAN - ARRIBA';
      case 'CB':
        return 'CAMBIO DE PLAN - ABAJO';
      default:
        return '';
    }
  }

  dividirNombresCompleto(nombreCompleto: string) {
    const partes = nombreCompleto.trim().split(/\s+/); // divide por espacios múltiples
    let primerApellido = '';
    let segundoApellido = '';
    let primerNombre = '';
    let segundoNombre = '';

    if (partes.length >= 4) {
      primerApellido = partes[0];
      segundoApellido = partes[1];
      primerNombre = partes[2];
      segundoNombre = partes.slice(3).join(' '); // por si hay más nombres
    } else if (partes.length === 3) {
      primerApellido = partes[0];
      segundoApellido = partes[1];
      primerNombre = partes[2];
    } else if (partes.length === 2) {
      primerApellido = partes[0];
      primerNombre = partes[1];
    }

    return {
      primerApellido,
      segundoApellido,
      primerNombre,
      segundoNombre,
    };
  }


  getFechaHoraISO(): string {
    // Genera la fecha actual en la zona horaria de Ecuador
    const fechaEcuador = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Guayaquil' })
    );

    // Obtén la zona horaria de Ecuador (-05:00)
    const offset = -5; // Ecuador está en UTC-5
    const sign = offset >= 0 ? '+' : '-';
    const hoursOffset = String(Math.abs(offset)).padStart(2, '0');
    const minutesOffset = '00';

    // Formatea la fecha y hora
    const year = fechaEcuador.getFullYear();
    const month = String(fechaEcuador.getMonth() + 1).padStart(2, '0');
    const day = String(fechaEcuador.getDate()).padStart(2, '0');
    const hours = String(fechaEcuador.getHours()).padStart(2, '0');
    const minutes = String(fechaEcuador.getMinutes()).padStart(2, '0');
    const seconds = String(fechaEcuador.getSeconds()).padStart(2, '0');

    // Devuelve formato ISO con zona horaria
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${sign}${hoursOffset}:${minutesOffset}`;
  }


  formatearFechaEcuador(date: Date, includeTime: boolean = false): string {
    const fechaEcuador = new Date(
      date.toLocaleString('en-US', { timeZone: 'America/Guayaquil' })
    );

    const year = fechaEcuador.getFullYear();
    const month = String(fechaEcuador.getMonth() + 1).padStart(2, '0');
    const day = String(fechaEcuador.getDate()).padStart(2, '0');

    if (!includeTime) {
      return `${year}-${month}-${day}`;
    }

    const hours = String(fechaEcuador.getHours()).padStart(2, '0');
    const minutes = String(fechaEcuador.getMinutes()).padStart(2, '0');
    const seconds = String(fechaEcuador.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  getFechaEcuador(): string {
    const fechaEcuador = new Date(
      new Date().toLocaleString('en-US', { timeZone: 'America/Guayaquil' })
    );

    const year = fechaEcuador.getFullYear();
    const month = String(fechaEcuador.getMonth() + 1).padStart(2, '0');
    const day = String(fechaEcuador.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }



  addCleanParams(httpParams: HttpParams, filters: Record<string, any>) {
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (typeof value === 'boolean' || typeof value === 'number') {
      httpParams = httpParams.set(key, String(value));
      return;
    }
    const str = String(value).trim();
    if (!str) return;

    const low = str.toLowerCase();
    if (low === 'null' || low === 'undefined' || low === 'none') return;

    httpParams = httpParams.set(key, str);
  });

  return httpParams;
}

}




